module.exports = "/assets/data/ea0a6e4832235ab9eec7ac174799f47a-EX3.data.json";